import {
    BooleanInput, Create, DateInput, Edit,
    Form,
    NullableBooleanInput, NumberInput, SelectInput, TextInput, Toolbar,
    TransformData,
    useRecordContext
} from "react-admin";
import { Card, CardContent, CardHeader, Divider, Grid, Stack } from "@mui/material";
import { ProfileSelectInput } from "@/src/components";
import { LANGUAGES } from "@/src/services";
import { emptify } from "@/src/utils";

const transform: TransformData = (data: any) => {

    emptify(data, "profile")

    return data;
}

export const AnnounceEdit = () =>
    <Edit transform={transform}>
        <Form sanitizeEmptyValues>
            <AnnounceEditFields />
        </Form>
    </Edit>


export const AnnounceCreate = () =>
    <Create transform={transform}>
        <Form sanitizeEmptyValues>
            <AnnounceEditFields />
        </Form>
    </Create>


const AnnounceEditFields = () => {
    const record = useRecordContext();
    return (
        <Card>
            <CardContent>
                <BooleanInput variant="outlined" source="active" />
                {record && <>
                    <TextInput variant="outlined" source="id" readOnly />
                    <Stack direction="row" spacing={2}>
                        <DateInput variant="outlined" source="createdAt" readOnly />
                        <DateInput variant="outlined" source="updatedAt" readOnly />
                    </Stack>
                </>}
                <Stack direction="row" spacing={2}>
                    <SelectInput variant="outlined" source='language'
                        label="UI language"
                        choices={LANGUAGES} />
                    <NumberInput variant="outlined" source="delay" />
                </Stack>


                <Stack direction="row" spacing={2}>
                    <DateInput variant="outlined" source="startsOn" />
                    <DateInput variant="outlined" source="endsOn" />
                </Stack>
                <SelectInput variant="outlined" source="type"
                    choices={[
                        { id: 'info', name: "Info" },
                        { id: 'success', name: "Success" },
                        { id: 'warning', name: "Warning" },
                        { id: 'error', name: "Error" },
                        { id: 'default', name: "Default" },
                    ]}
                />
                <TextInput variant="outlined" source="content" label="Content" multiline rows={4} fullWidth />
                <TextInput variant="outlined" source="email" label="Email for testing" />

                <Divider>Filter</Divider>
                <Grid container spacing={2} columns={{ xs: 1, sm: 2, md: 3, lg: 4 }}>
                    <Grid size={1}>
                        <NullableBooleanInput variant="outlined" source="hasPhoto" />
                    </Grid>
                    <Grid size={1}>
                        <NullableBooleanInput variant="outlined" source="isPremium" />
                    </Grid>
                    <Grid size={1}>
                        <ProfileSelectInput variant="outlined" source="profile.gender" label="Gender" />
                    </Grid>
                    <Grid size={1}>
                        <ProfileSelectInput variant="outlined" source="profile.isSponsor" label="Is Sponsor" />
                    </Grid>
                    <Grid size={1}>
                        <ProfileSelectInput variant="outlined" source="profile.purpose" label="Purpose" pre={[{ id: "na", name: "NA" }]} />
                    </Grid>
                    <Grid size={1}>
                        <ProfileSelectInput variant="outlined" source="profile.datingAs" label="Dating as" />
                    </Grid>
                    <Grid size={1}>
                        <ProfileSelectInput variant="outlined" source="profile.sexOrientation" label="Sex orientation" />
                    </Grid>
                </Grid>


            </CardContent>
            <Toolbar />
        </Card>)
}